export const parseReviewsBreakdown = (reviewsBreakdown) => {
  const storesWithReviews = reviewsBreakdown.filter(
    (breakdown) => breakdown.count > 0
  )
  const globalCount = reviewsBreakdown.reduce(
    (acc, breakdown) => acc + breakdown.count,
    0
  )
  const globalRating = reviewsBreakdown.reduce(
    (acc, breakdown) => acc + breakdown.rating / storesWithReviews.length,
    0
  )

  const globalStarsBreakdown = {
    rating1: 0,
    rating2: 0,
    rating3: 0,
    rating4: 0,
    rating5: 0,
  }

  storesWithReviews.forEach((store) => {
    globalStarsBreakdown.rating1 += parseInt(store.breakdown.rating1)
    globalStarsBreakdown.rating2 += parseInt(store.breakdown.rating2)
    globalStarsBreakdown.rating3 += parseInt(store.breakdown.rating3)
    globalStarsBreakdown.rating4 += parseInt(store.breakdown.rating4)
    globalStarsBreakdown.rating5 += parseInt(store.breakdown.rating5)
  })

  return {
    global: {
      count: globalCount,
      rating: globalRating,
      stars_breakdown: globalStarsBreakdown,
    },
    stores: storesWithReviews,
  }
}
